import { Breakpoints as E } from "../../style/base/index.js";
import { convertToHtmlId as a } from "../../utils/convert-to-html-id.js";
const h = E.LARGE, c = ["Phase 1", "Phase 2", "Phase 3", "Filed", "Approved"], I = new Set(c), m = {
  "Phase 1": "P1",
  "Phase 2": "P2",
  "Phase 3": "P3",
  Filed: "Fil.",
  Approved: "App."
}, u = c.map((e) => ({
  id: a(e),
  label: e,
  shortLabel: m[e]
})), f = (e, r) => {
  const o = {};
  for (const n of e) {
    const t = r(n);
    if (!I.has(t))
      continue;
    const i = a(t);
    o[i] = (o[i] ?? 0) + 1;
  }
  return o;
}, A = (e, r, o) => {
  const n = /* @__PURE__ */ new Map();
  for (const t of e) {
    const i = o(t);
    if (!I.has(i))
      continue;
    const P = r(t), p = a(i);
    let s = n.get(P);
    s || (s = { id: a(P), label: P, items: [], itemsByLaneId: {} }, n.set(P, s)), s.items.push(t), s.itemsByLaneId[p] || (s.itemsByLaneId[p] = []), s.itemsByLaneId[p].push(t);
  }
  return Array.from(n.values());
};
export {
  u as PIPELINE_LANES,
  h as PIPELINE_MOBILE_BREAKPOINT,
  c as PIPELINE_PHASE_ORDER,
  f as countPipelineItemsByLane,
  A as groupPipelineItems
};
